<template>
    
    <v-card v-if="!loginEmail.includes('pasla')">
        <v-card-title>
            {{$t('event.guests')}}
            <v-spacer></v-spacer>
            <v-btn class="mr-3" :disabled="!selectedGuests.length" :dark="!!selectedGuests.length" color="red" @click="deleteGuest">
                Delete Selected ({{selectedGuests.length}})
            </v-btn>
            <v-btn color="primary" @click="$router.push({name: 'guest-batch-add'})">
                {{$t('Add Guests')}}
                <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col class="pt-0">
                    <v-text-field v-model="search"
                                  append-icon="mdi-magnify"
                                  :label="$t('search')"
                                  single-line
                                  hide-details
                                  clearable>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-data-table :headers="headers"
                          :items="eventGuests"
                          :loading="isEventGuestPending"
                          :search="search"
                          show-select
                          v-model="selectedGuests"
                          no-data-text="No Guests"
                          :footer-props="{
                            'items-per-page-options': [10, 50, 100, 500, -1]
                          }"
                          >
                <template v-slot:item.createdAt="{value}">
                    {{DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm')}}
                </template>
                <template v-slot:item.actions="{item}">
                    <v-btn color="primary"
                    :to="{name: 'event-guests-edit', params: {guestId: item.guestId}}">
                        {{$t('edit')}}
                        <v-icon right>mdi-pencil</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>
        
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        
        <v-dialog v-model="dialog" scrollable max-width="640px">
            <v-card>
                <v-card-text style="height: 360px; padding: 15px" v-html="dialogMsg">
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <RouterView></RouterView>
    </v-card>
    <v-card v-else-if="loginEmail.includes('pasla')" outlined>
        <iframe :src="paslaIframeSrc" width="100%" height="800" frameborder="0" allowfullscreen></iframe>
    </v-card>
</template>

<script>
    import {computed, ref} from "@vue/composition-api";
    import {useFind} from "feathers-vuex";
    import feathersClient from "@/feathers-client";
    import {DateTime} from "luxon";

    export default {
        name: 'EventGuestList',
        props: {
            companyId: String,
        },
        setup(props, {root}) {
            const paslaIframeId = process.env.NODE_ENV === 'production' ? ref(['a0711058-fc9a-4bd2-9a22-4886810ab3bb']) : ref(['e96ab950-e3d6-4b52-917d-3fcc00614735']);
            const paslaIframeSrc = process.env.NODE_ENV === 'production' ? 'https://ff.eventionapp.com/pasla2025_login/login?token=mobfjaskfkjvoavmco32432lkeacowaopewdoijewdojw4234ewfjdhuewifhile' : 'https://uat.eventionapp.com/pasla2025_login/login?token=mobfjaskfkjvoavmco32432lkeacowaopewdoijewdojw4234ewfjdhuewifhile';
            const {EventGuest} = root.$FeathersVuex.api;
            const loginEmail = root.$store.state.auth.user.email;
            const eventId = computed(() => root.$route.params.eventId);
            
            const overlay = ref(false);
            const dialog = ref(false);
            const dialogMsg = ref('');
            const selectedGuests = ref([]);
            
            const eventGuestParams = computed(() => {
                let params = {
                    query: {
                        eventId: eventId.value,
                        // includeGuest: true,
                        $sort: {
                            createdAt: -1,
                        }
                    }
                };
                return params;
            });
            const {items: eventGuests, isPending: isEventGuestPending} = useFind({
                model: EventGuest,
                params: eventGuestParams
            });

            // Data Table
            const headers = ref([
                {text: root.$t('Username'), value: 'guests.username'},
                {text: root.$t('First Name'), value: 'ev_firstname'},
                {text: root.$t('Last Name'), value: 'ev_lastname'},
                {text: root.$t('Created At'), value: 'createdAt'},
                {text: '', value: 'actions', filterable: false, width: '120', align: 'end'},
            ]);
            
            const deleteGuest = async () => {
                if (confirm(root.$t('user.confirm_delete'))) {
                    overlay.value = true;

                    let selectedGuests_array = [];
                    if (selectedGuests.value.length === 0) {
                        overlay.value = false;
                        return;
                    } else if (selectedGuests.value.length > 20) {
                        for (let i = 0; i < selectedGuests.value.length; i += 20) {
                            selectedGuests_array.push(selectedGuests.value.slice(i, i + 20));
                        }
                    } else {
                        selectedGuests_array.push(selectedGuests.value);
                    }

                    for (let i = 0; i < selectedGuests_array.length; i++) {
                        await feathersClient.service('event-guests').remove(null, {
                            query: {
                                id: {
                                    $in: selectedGuests_array[i].map(g => g.id)
                                }
                            }
                        }).then(() => {
                            selectedGuests.value = selectedGuests.value.filter(g => !selectedGuests_array[i].includes(g));
                        }).catch(e => {
                            overlay.value = false;
                            root.$store.dispatch('showSnackBar', e.message);
                            return;
                        });
                    }

                    overlay.value = false;
                    root.$store.dispatch('showSnackBar', 'Guests Deleted.');

                    // let count = 0;
                    // let errorCount = 0;
                    // let errorMsg = '';
                
                    // let i = selectedGuests.value.length;
                    // while (i--) {
                    //     let temp = await selectedGuests.value[i].remove().then(() => {
                    //         selectedGuests.value.splice(i, 1);
                    //         return false;
                    //     }, (e) => {
                    //         return e.errors ? e.errors.map ? (e.errors.map(a => a.message)).join('; ') : e.message : e.statusText;
                    //     });
                    //     count++;
                    //     if (temp) {
                    //         errorMsg = '<li>' + temp + '</li>' + errorMsg;
                    //         errorCount++;
                    //     }
                    // }
                
                    // overlay.value = false;
                    // if (errorCount) {
                    //     dialogMsg.value = (count - errorCount) + ' of ' + count + ' Guest(s) sucessfully deleted.<br><br>' + (errorCount) + ' of ' + count + ' Guest(s) NOT deleted:<br><ul>' + errorMsg + '</ul>';
                    //     dialog.value = true;
                    // } else {
                    //     dialogMsg.value = '';
                    //     root.$store.dispatch('showSnackBar', count + ' Guest(s) Deleted.' + errorMsg);
                    // }
                }
            };

            return {
                loginEmail,
                paslaIframeId,
                paslaIframeSrc,
                selectedGuests,
                deleteGuest,
                overlay,
                dialog,
                dialogMsg,

                isEventGuestPending,
                eventGuests,

                headers,
                search: ref(''),
                DateTime
            }
        }
    }
</script>
